// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getContacts as listContactsAPI,
    getContact as getContactAPI,
    addContact as addContactAPI,
    updateContact as updateContactAPI,
    deleteContact as deleteContactAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { contactsApiResponseError, contactsApiResponseSuccess } from './actions';
import { ContactsActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getContact({ payload: { id } }) {
    try {
        const response = yield call(getContactAPI, id);
        const contactItem = response.data.data;
        yield put(contactsApiResponseSuccess(ContactsActionTypes.GET_CONTACT, contactItem));
    } catch (error) {
        yield put(contactsApiResponseError(ContactsActionTypes.GET_CONTACT, error));
    }
}

function* addContact({ payload: contact }) {
    try {
        const response = yield call(addContactAPI, { ...contact })
        const contactItem = response.data
        yield put(contactsApiResponseSuccess(ContactsActionTypes.ADD_CONTACT, contactItem))
    } catch (error) {
        yield put(contactsApiResponseError(ContactsActionTypes.ADD_CONTACT, error))
    }
}

function* updateContact({ payload: contact }) {
    try {
        const response = yield call(updateContactAPI, { ...contact })
        const contactItem = response.data.data
        yield put(contactsApiResponseSuccess(ContactsActionTypes.UPDATE_CONTACT, contactItem))
    } catch (error) {
        yield put(contactsApiResponseError(ContactsActionTypes.UPDATE_CONTACT, error))
    }
}
function* deleteContact({ payload: { id } }) {
    try {
        const response = yield call(deleteContactAPI, id)
        const contactItem = response.data.id
        yield put(contactsApiResponseSuccess(ContactsActionTypes.DELETE_CONTACT, contactItem))
    } catch (error) {
        yield put(contactsApiResponseError(ContactsActionTypes.DELETE_CONTACT, error))
    }
}

/**
 * List contactos
 */
function* listContacts({ payload: params }) {
    try {
        const response = yield call(listContactsAPI, { ...params });
        const listaContacts = response.data.data;
        yield put(contactsApiResponseSuccess(ContactsActionTypes.LIST_CONTACTS, listaContacts));
    } catch (error) {
        yield put(contactsApiResponseError(ContactsActionTypes.LIST_CONTACTS, error));
    }
}


export function* watchGetContact(): any {
    yield takeEvery(ContactsActionTypes.GET_CONTACT, getContact);
}

export function* watchListContacts(): any {
    yield takeEvery(ContactsActionTypes.LIST_CONTACTS, listContacts);
}

export function* watchAddContact(): any {
    yield takeEvery(ContactsActionTypes.ADD_CONTACT, addContact)
}
export function* watchUpdateContact(): any {
    yield takeEvery(ContactsActionTypes.UPDATE_CONTACT, updateContact)
}
export function* watchDeleteContact(): any {
    yield takeEvery(ContactsActionTypes.DELETE_CONTACT, deleteContact)
}


function* contactsSaga(): any {
    yield all([
        fork(watchGetContact),
        fork(watchListContacts),
        fork(watchAddContact),
        fork(watchUpdateContact),
        fork(watchDeleteContact),
    ]);
}

export default contactsSaga;
